import * as React from 'react'
import usePagination from '@mui/material/usePagination'
import { Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import AdxInfoModal from 'components/reusable/modal/AdxInfoModal'
import AdxButton from 'components/custom/AdxButton'

const List = styled('ul')({
  listStyle: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
})

export default function PageNavigator({
  pageCount,
  pageCurrent,
  handlePage,
  handleExit,
  isPreview,
  isSubmission,
  handleSubmit,
  handleOpen,
  isModalOpen,
  setModalOpen,
}) {
  const { items } = usePagination({
    count: pageCount,
    hideNextButton: pageCurrent + 1 === pageCount ? true : false,
    boundaryCount: 99,
    siblingCount: 99,
  })

  React.useEffect(() => {
    let test = items.find((i) => i.selected === true)
    handlePage(test.page)
  }, [items])

  const handleClose = () => {
    setModalOpen(false)
  }

  return (
    <>
      <nav>
        <List>
          {items.map(({ page, type, selected, ...item }, index) => {
            let children = null

            if (type === 'start-ellipsis' || type === 'end-ellipsis') {
              children = '…'
            } else if (type === 'previous') {
              children = (
                <AdxButton
                  variant={'outlined'}
                  sx={{ width: 200, height: 50, borderRadius: '8.25px' }}
                  size="small"
                  {...item}
                >
                  <Typography variant="h4">Previous</Typography>
                </AdxButton>
              )
            } else if (type === 'next') {
              children = (
                <AdxButton
                  variant={'contained'}
                  sx={{ width: 200, height: 50, marginLeft: '15px', borderRadius: '8.25px' }}
                  size="small"
                  {...item}
                >
                  <Typography variant="h4">Next</Typography>
                </AdxButton>
              )
            }

            return <li key={index}>{children}</li>
          })}
          {pageCurrent + 1 === pageCount && isPreview ? (
            <AdxButton
              variant={'contained'}
              sx={{ width: 200, height: 50, marginLeft: '15px', borderRadius: '8.25px' }}
              size="small"
              onClick={() => handleExit()}
            >
              <Typography variant="h4">End preview</Typography>
            </AdxButton>
          ) : pageCurrent + 1 === pageCount && isSubmission ? (
            <AdxButton
              variant={'contained'}
              sx={{ width: 200, height: 50, marginLeft: '15px', borderRadius: '8.25px' }}
              size="small"
              onClick={handleOpen}
            >
              <Typography variant="h4">Submit</Typography>
            </AdxButton>
          ) : null}
        </List>
      </nav>

      {/* Confirmation modal to submit answered evaluation */}
      <AdxInfoModal
        variant="standard"
        open={isModalOpen}
        onClose={handleClose}
        muiIcon="check_circle"
        iconColor="positive.main"
        title="Are you sure you want to submit?"
        subtitle="Press confirm to submit"
        footerButtons
        firstBtnLabel={'Confirm'}
        firstBtnHandle={handleSubmit}
        secondBtnLabel={'Cancel'}
        secondBtnHandle={handleClose}
      />
    </>
  )
}
